import { render, staticRenderFns } from "./aggrid-labarugi.vue?vue&type=template&id=e3d502b8&scoped=true"
import script from "./aggrid-labarugi.vue?vue&type=script&lang=js"
export * from "./aggrid-labarugi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d502b8",
  null
  
)

export default component.exports